module.exports = __webpack_public_path__ + "img/lachmania_yes.a12c8a78.png";